export default __webpack_public_path__ + "static/media/geometry-artwork-10.aeac27ca.jpg";